import React from 'react';
import type { TestStatus } from '../model';
import { Icon, IconName } from './icons';

const ICON: Record<TestStatus, IconName> = {
  draft: 'pencil',
  public: 'users',
  assigned: 'usercheck',
  archived: 'archive',
};

const CLASS: Record<TestStatus, string> = {
  draft: 'tw-pill-draft',
  public: 'tw-pill-public',
  assigned: 'tw-pill-given',
  archived: 'tw-pill-archive',
};

/** Слово состояния со значком: состояние не передаётся одним цветом. */
export const StatusPill: React.FC<{ status: TestStatus; label: string }> = ({ status, label }) => (
  <span className={`tw-pill ${CLASS[status]}`}>
    <Icon name={ICON[status]} size={20} />
    <span>{label}</span>
  </span>
);
